export enum Protocol {
  ID = 0,
  SECP256K1 = 1,
  ACTOR = 2,
  BLS = 3,
  DELEGATED = 4
}

export enum DelegatedNamespace {
  EVM = 10
}
